<script>
  import Modal from './components/Modal.svelte';
  import KeyHandler from './components/KeyHandler.svelte';
  import {
    relativeTimestamps,
    localDates,
  } from './settings.js';

  let open = false;

  const keyHandlers = {
    't': () => $relativeTimestamps = $relativeTimestamps !== true,
    'z': () => $localDates = $localDates !== true,
    '?': () => open = open !== true,
	};

</script>

<KeyHandler handlers={keyHandlers} />
<div>
{#if open}
	<Modal on:close="{() => open = false}">
		<h1 slot='header'>help</h1>
    <table>
      <tr>
        <th>key</th>
        <th>action</th>
      </tr>
      <tr>
        <td>t</td>
        <td>toggle relative timestamps</td>
      </tr>
      <tr>
        <td>z</td>
        <td>toggle local/UTC timestamps</td>
      </tr>
      <tr>
        <td>↑</td>
        <td>change selected entry</td>
      </tr>
      <tr>
        <td>↓</td>
        <td>change selected entry</td>
      </tr>
      <tr>
        <td>⏎</td>
        <td>expand/collapse selected entry</td>
      </tr>
      <tr>
        <td>?</td>
        <td>show this help dialog</td>
      </tr>
    </table>
		<h2>settings</h2>
    <div class='box'>
      <div class='row'>
        <div>relative timestamps</div>
        <div>{$relativeTimestamps}</div>
      </div>
      <div class='row'>
        <div>local dates</div>
        <div>{$localDates}</div>
      </div>
    </div>
	</Modal>
{:else}
  <div class='icon' on:click={() => open = true}>?</div>
{/if}
</div>

<style>
  h1 {
    margin-top: 0;
  }
  table {
    border-spacing: 1rem 0.5rem;
  }
  th:last-child {
    text-align: left;
  }
  td {
    font-size: 1.2rem;
  }
  td:first-child {
    padding: 0.2rem 0.4rem;
    color: #000;
    text-align: center;
    font-weight: 600;
    font-size: 1.2rem;
    background: white;
    border: 2px solid rgba(0,0,0,0.25);
    border-radius: 4px;
  }
  .box {
    display: flex;
    flex-direction: column;
    font-size: 1.2rem;
  }
  .row {
    display: flex;
    justify-content: space-between;
    padding: 0.2rem 0;
  }
  .icon {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.5rem 1rem;
    width: 1.5rem;
    height: 1.5rem;
    border: 2px solid white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 600;
    opacity: 0.4;
    transition: all 100ms ease-in-out;
  }
  .icon:hover {
    opacity: 1.0;
    cursor: pointer;
  }
</style>
